'use strict';

angular.module('msLegacyActivities').controller('ActivityListCtrl', ['$scope', 'activitySvc', function ($scope, activitySvc) {
  activitySvc.getTags(true).then(function (tags) {
    $scope.tags = tags;
  });
}]);